import React from 'react'

const Flag = props => {
  // https://github.com/lipis/flag-icons
  const { code, square, ...restProps } = props

  const flagCode = (code?.toLowerCase() === 'uk' ? 'gb' : code?.toLowerCase()) || ''

  return <span className={`fi fi-${flagCode} ${square && 'fis'}`} {...restProps} />
}

export default Flag
